<svg version="1.1" id="avatar-svg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
   viewBox="0 0 202.4 235" style="enable-background:new 0 0 202.4 235;" xml:space="preserve">
<style type="text/css">
  #avatar-svg .st0{fill:url(#avatar-SVGID_1_);}
  #avatar-svg .st1{fill:url(#avatar-SVGID_2_);}
  #avatar-svg .st2{fill:#FFF2D1;}
  #avatar-svg .st3{fill:url(#avatar-SVGID_3_);}
  #avatar-svg .st4{fill:url(#avatar-SVGID_4_);}
  #avatar-svg .st5{fill:url(#avatar-SVGID_5_);}
  #avatar-svg .st6{fill:none;stroke:#545454;stroke-width:0.5711;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
  #avatar-svg .st7{fill:none;stroke:#F7F7F7;stroke-width:0.5711;stroke-miterlimit:10;}
  #avatar-svg .st8{clip-path:url(#avatar-SVGID_7_);}
  #avatar-svg .st9{clip-path:url(#avatar-SVGID_9_);}
  #avatar-svg .st10{filter:url(#Adobe_OpacityMaskFilter);}
  #avatar-svg .st11{filter:url(#Adobe_OpacityMaskFilter_1_);}
  #avatar-svg .st12{filter:url(#Adobe_OpacityMaskFilter_2_);}
  #avatar-svg .st13{fill:#630002;}
  #avatar-svg .st14{font-family:'Chalkduster';}
  #avatar-svg .st15{font-size:11.008px;}
  .username{text-align: center;text-anchor: middle;}
</style>
<g id="avatar-inner-wrap">
  <g id="background">
    <g>

        
      <g>

          <linearGradient id="avatar-SVGID_1_" gradientUnits="userSpaceOnUse" x1="40.7276" y1="282.291" x2="72.342" y2="334.3628" gradientTransform="matrix(0.984 -0.1782 0.1782 0.984 35.6642 -125.1093)">
          <stop  offset="0" style="stop-color:#FFF6E0"/>
          <stop  offset="1" style="stop-color:#DBC795"/>
        </linearGradient>
        <polygon class="st0" points="179.7,185.9 43.7,210.5 12.3,37 148.3,12.4         "/>
      </g>
    </g>

      <radialGradient id="avatar-SVGID_2_" cx="16.9824" cy="671.1965" r="61.2782" gradientTransform="matrix(0.984 -0.1782 2.742664e-02 0.1515 75.4223 94.4385)" gradientUnits="userSpaceOnUse">
      <stop  offset="0" style="stop-color:#000000"/>
      <stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>
    </radialGradient>
    <polygon class="st1" points="181.8,198.6 45.8,223.2 39.3,187.6 175.3,163     "/>

      <rect x="26.9" y="23.3" transform="matrix(0.984 -0.1782 0.1782 0.984 -18.3275 18.8891)" class="st2" width="138.2" height="176.3"/>

      <linearGradient id="avatar-SVGID_3_" gradientUnits="userSpaceOnUse" x1="40.7276" y1="282.291" x2="72.342" y2="334.3628" gradientTransform="matrix(0.984 -0.1782 0.1782 0.984 35.6642 -125.1093)">
      <stop  offset="0" style="stop-color:#FFF6E0"/>
      <stop  offset="1" style="stop-color:#DBC795"/>
    </linearGradient>
    <polygon class="st3" points="179.7,185.9 43.7,210.5 12.3,37 148.3,12.4     "/>

      <linearGradient id="avatar-SVGID_4_" gradientUnits="userSpaceOnUse" x1="40.7276" y1="282.291" x2="72.342" y2="334.3628" gradientTransform="matrix(0.984 -0.1782 0.1782 0.984 35.6642 -125.1093)">
      <stop  offset="0" style="stop-color:#FFF6E0"/>
      <stop  offset="1" style="stop-color:#DBC795"/>
    </linearGradient>
    <polygon class="st4" points="179.7,185.9 43.7,210.5 12.3,37 148.3,12.4     "/>

      <linearGradient id="avatar-SVGID_5_" gradientUnits="userSpaceOnUse" x1="-29.0804" y1="178.0869" x2="19.1225" y2="240.1654" gradientTransform="matrix(0.984 -0.1782 0.1782 0.984 35.6642 -125.1093)">
      <stop  offset="0" style="stop-color:#AFB3C4"/>
      <stop  offset="1" style="stop-color:#4F87A1"/>
    </linearGradient>
    <path class="st5" d="M158.2,164.8L54,183.7c-2.2,0.4-4.2-1-4.6-3.2L25.5,48.6c-0.4-2.2,1-4.2,3.2-4.6l104.2-18.9
      c2.2-0.4,4.2,1,4.6,3.2l23.9,131.9C161.8,162.4,160.4,164.4,158.2,164.8z"/>
    <path class="st6" d="M49.1,179.1L25.7,49.7c-0.5-2.7,1.3-5.3,4-5.8L132,25.3"/>
    <path class="st7" d="M138,30l23.4,129.4c0.5,2.7-1.3,5.3-4,5.8L55,183.8"/>
    <g>
      <defs>

          <rect id="avatar-SVGID_6_" x="149.4" y="25.3" transform="matrix(0.984 -0.1782 0.1782 0.984 -14.3492 29.2327)" width="12.3" height="138.5"/>
      </defs>
      <clipPath id="avatar-SVGID_7_">
        <use xlink:href="#avatar-SVGID_6_"  style="overflow:visible;"/>
      </clipPath>
      <g id="schets_x5F_0003_x5F_poging_x5F_348.psd_2_" class="st8">
        <defs>

            <rect id="avatar-SVGID_8_" x="-27.6" y="36.1" transform="matrix(0.984 -0.1782 0.1782 0.984 -19.2991 19.9149)" width="257.6" height="162.6"/>
        </defs>
        <clipPath id="avatar-SVGID_9_">
          <use xlink:href="#avatar-SVGID_8_"  style="overflow:visible;"/>
        </clipPath>
        <g class="st9">

        </g>
        <g id="arm_1_" class="st9">
          <defs>
            <filter id="Adobe_OpacityMaskFilter" filterUnits="userSpaceOnUse" x="-40" y="14.5" width="282.4" height="205.9">
              <feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
            </filter>
          </defs>
          <mask maskUnits="userSpaceOnUse" x="-40" y="14.5" width="282.4" height="205.9" id="arm_2_">
            <g id="armOpacity_Mask_2_" class="st10">
            </g>
          </mask>
          <g style="mask:url(#arm_2_);">
          </g>
          <defs>
            <filter id="Adobe_OpacityMaskFilter_1_" filterUnits="userSpaceOnUse" x="-40" y="14.5" width="282.4" height="205.9">
              <feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
            </filter>
          </defs>
          <mask maskUnits="userSpaceOnUse" x="-40" y="14.5" width="282.4" height="205.9" id="Layer_7_1_">
            <g id="Layer_7Opacity_Mask_2_" class="st11">
            </g>
          </mask>
          <g style="mask:url(#Layer_7_1_);">
          </g>
          <defs>
            <filter id="Adobe_OpacityMaskFilter_2_" filterUnits="userSpaceOnUse" x="-40" y="14.5" width="282.4" height="205.9">
              <feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
            </filter>
          </defs>
          <mask maskUnits="userSpaceOnUse" x="-40" y="14.5" width="282.4" height="205.9" id="Layer_8_1_">
            <g id="Layer_8Opacity_Mask_2_" class="st12">

            </g>
          </mask>
          <g style="mask:url(#Layer_8_1_);">
          </g>
        </g>
      </g>
    </g>
  </g>
  <g id="profile-picture-wrapper">
    <defs>

        <rect id="avatar-SVGID_10_" x="33.5" y="35.7" transform="matrix(0.984 -0.1782 0.1782 0.984 -17.1229 19.1608)" width="129.1" height="138.5"/>
    </defs>
    <clipPath id="avatar-SVGID_11_">
      <use xlink:href="#avatar-SVGID_10_"  style="overflow:visible;"/>
    </clipPath>
    <g style="clip-path:url(#avatar-SVGID_11_);">
<!-- INPUT THE CHARACTER IMAGE HERE -->
        <image style="overflow:visible;" width="1177" height="610" id="myavatarImage" xlink:href="img\avatar\avatars\Avatar_3.1.3.1.png"  transform="matrix(0.24, 0, 0, 0.24, -52, 55.3084) rotate(-9)">
      </image>
    </g>
  </g>
  <text id="avatarUsername" transform="matrix(0.984 -0.1782 0.1782 0.984 109.8768 189.623)" class="st13 st14 st15 username">-* {{username}} *-</text>
</g>
</svg>
